// Blog.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NewsCard from './NewsCard';
import { Grid } from '@mui/material';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios.get('https://www.blog.mfchub.com/wp-json/wp/v2/posts/')
      .then(response => {
        if (Array.isArray(response.data)) {
          setBlogs(response.data);
        } else {
          console.error('Unexpected response format:', response.data);
          setBlogs([]);
        }
      })
      .catch(error => {
        console.error('Error fetching blogs:', error);
        setBlogs([]);
      });
  }, []);

  return (
    <div>
      <h3 style={{ marginTop: '50px', marginBottom: '0px', marginLeft: '5vw'}}>Blog</h3>
      <Grid container spacing={3}>
        {blogs.slice(0, 3).map(item => (
          <Grid item key={item.id} xs={12} sm={6} md={4}>
            <NewsCard
              title={item.title.rendered}
              excerpt={item.excerpt.rendered}
              image={item.featured_media ? `https://www.blog.mfchub.com/wp-json/wp/v2/media/${item.featured_media}` : 'https://via.placeholder.com/150'}
              url={item.link}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Blog;